import Layout from "../Shared/Layout";
import AddQuotationDetails from "./AddQuotationDetails";

const AddQuotationPage = () => {
    return (
        <Layout>
            <AddQuotationDetails />

        </Layout>
    )
}

export default AddQuotationPage;